/**
 * External dependencies
 */
import { __ } from "@wordpress/i18n";
import { useDispatch, useSelect } from "@wordpress/data";
import { dateYmdToFormattedDate } from "@wds/blocks/common/helper";
import { SUBSCRIPTIONS_STORE_NAME as STORE_NAME } from "../../constants";

/**
 * Internal dependencies
 */
import Popup from "@wds/blocks/common/popup";
import SelectedSlot from "./SelectedSlot";
import subscriptionIcon from "../../common/images/subscription-icon.svg";
import PopupContent from "../components/PopupContent";
import ProductNames from "./ProductNames";

const SubscriptionPopup = ({ type }) => {
	const popupOpen = useSelect((select) => select(STORE_NAME).getPopupOpen());
	const { setPopupOpen } = useDispatch(STORE_NAME);
	const reservedSlot = useSelect((select) =>
		select(STORE_NAME).getReservedSlot(type)
	);
	const dateYmd = useSelect((select) => select(STORE_NAME).getDateYmd(type));
	const formattedDate = dateYmd ? dateYmdToFormattedDate(dateYmd) : null;
	const timeslot = useSelect((select) => select(STORE_NAME).getTimeslot(type));

	return (
		<div className="wds-fieldbox-sub-field">
			{type === popupOpen && (
			<Popup
				headerImage={<img src={subscriptionIcon} alt="Subscription icon" />}
				headerTitle={
				<>
					<span>
						{type === "subscription"
							? __("Set up subscription", "jckwds")
							: __("Select delivery slot", "jckwds")}
					</span>
					<span className="wds-fieldbox-popup-subtitle">
						<ProductNames type={type} />
					</span>
				</>
				}
				onClose={() => setPopupOpen(false)}
			>
				<PopupContent />
			</Popup>
			)}

			<span className="wds-fieldbox-sub-field__title">
				{type === "subscription"
					? __("Subscription", "jckwds")
					: __("One-time purchase", "jckwds")}

				<span className="wds-fieldbox-sub-field__title-products">
					<ProductNames type={type} />
				</span>
			</span>

			<div className="wds-fieldbox-selector">
				<SelectedSlot type={type} />
				<div className="wds-fieldbox-selector__action">
					<span
					className="wds-fieldbox-selector__action-title"
					onClick={() => {
						setPopupOpen(type);
					}}
					>
					{reservedSlot ? __("Change", "jckwds") : __("+ Set up", "jckwds")}
					</span>
				</div>
			</div>

			<input
				type="hidden"
				name={`iconic-wds-subscription-date[${type}]`}
				value={formattedDate ?? ""}
			/>
			<input
				type="hidden"
				name={`iconic-wds-subscription-date-ymd[${type}]`}
				value={dateYmd ?? ""}
			/>
			<input
				type="hidden"
				name={`iconic-wds-subscription-timeslot[${type}]`}
				value={timeslot ?? ""}
			/>
		</div>
	);
};

export default SubscriptionPopup;
